var map = {
	"./de-DE/time": 10060,
	"./en-US/time": 65785,
	"./es-ES/time": 76234,
	"./fa-IR/time": 16338,
	"./fr-FR/time": 22758,
	"./hi-IN/time": 98380,
	"./it-IT/time": 70516,
	"./ja-JP/time": 2441,
	"./ko-KR/time": 30215,
	"./pl-PL/time": 33514,
	"./pt-BR/time": 37170,
	"./ro-RO/time": 83124,
	"./ru-RU/time": 85736,
	"./sl-SI/time": 22609,
	"./th-TH/time": 53986,
	"./tr-TR/time": 15778,
	"./uk-UA/time": 5284,
	"./vi-VN/time": 97771,
	"./zh-Hans/time": 83272,
	"./zh-Hant/time": 50027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55194;